<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h2 class="text-white">Fee Structure</h2>
                    <ul class="breadcrumb">
                        <li>
                            <a href="index.php">Home</a>
                        </li>/
                        <li class="active">
                            <a href="fee-structure.php">Fee Structure</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="minority-cell ptb--100 ">
    <div class="container">
        <div class="row">
            <div class="col">
                <div class="sec-title">
                    <h2><span>Raisoni Group Proposed Fees : 2024-25 </span></h2>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered  table--4">
                        <thead>
                            <tr>
                                <th>SR NO.</th>
                                <th>COURSE</th>
                                <th>TUITION FEES</th>
                                <th>UNI PRORETA</th>
                                <th>UNI ELIGIBILITY FEES</th>
                                <th>UNI MEDICAL FEES</th>
                                <th>STUDENT ACTIVITY FEES</th>
                                <th>ALUMNI MEMBERSHIP FEES</th>
                                <th>EXAM FEES</th>
                                <th>CONVOCATION FEES</th>
                                <th>TOTAL PER STUDENT FEES</th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>FY BBA</td>
                                <td>67,981</td>
                                <td>339</td>
                                <td>650</td>
                                <td>30</td>
                                <td>1,000</td>
                                <td>2,000</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>79,000</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>FY BBA (CA)</td>
                                <td>67,981</td>
                                <td>339</td>
                                <td>650</td>
                                <td>30</td>
                                <td>1,000</td>
                                <td>2,000</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>79,000</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>FY BBA (IB)</td>
                                <td>67,981</td>
                                <td>339</td>
                                <td>650</td>
                                <td>30</td>
                                <td>1,000</td>
                                <td>2,000</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>79,000</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>FY BCA (CS)</td>
                                <td>67,981</td>
                                <td>339</td>
                                <td>650</td>
                                <td>30</td>
                                <td>1,000</td>
                                <td>2,000</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>79,000</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>FY BSC (CS)</td>
                                <td>67,981</td>
                                <td>339</td>
                                <td>650</td>
                                <td>30</td>
                                <td>1,000</td>
                                <td>2,000</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>79,000</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>FY BSC (IT)</td>
                                <td>67,981</td>
                                <td>339</td>
                                <td>650</td>
                                <td>30</td>
                                <td>1,000</td>
                                <td>2,000</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>79,000</td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>FY BCOM</td>
                                <td>36,231</td>
                                <td>339</td>
                                <td>400</td>
                                <td>30</td>
                                <td>1,000</td>
                                <td>2,000</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>47,000</td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>SY BBA</td>
                                <td>58,661</td>
                                <td>339</td>
                                <td>0</td>
                                <td>0</td>
                                <td>1,000</td>
                                <td>0</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>67,000</td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>SY BCA</td>
                                <td>58,661</td>
                                <td>339</td>
                                <td>0</td>
                                <td>0</td>
                                <td>1,000</td>
                                <td>0</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>67,000</td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>SY BCom</td>
                                <td>36,661</td>
                                <td>339</td>
                                <td>0</td>
                                <td>0</td>
                                <td>1,000</td>
                                <td>0</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>45,000</td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>SY BSC</td>
                                <td>58,661</td>
                                <td>339</td>
                                <td>0</td>
                                <td>0</td>
                                <td>1,000</td>
                                <td>0</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>67,000</td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>TY BBA</td>
                                <td>42,500</td>
                                <td>339</td>
                                <td>0</td>
                                <td>0</td>
                                <td>1,000</td>
                                <td>0</td>
                                <td>7,000</td>
                                <td>1,500</td>
                                <td>52,339</td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>TY BCA</td>
                                <td>45,000</td>
                                <td>339</td>
                                <td>0</td>
                                <td>0</td>
                                <td>1,000</td>
                                <td>0</td>
                                <td>7,000</td>
                                <td>1,500</td>
                                <td>54,839</td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>TY BCom</td>
                                <td>32,000</td>
                                <td>339</td>
                                <td>0</td>
                                <td>0</td>
                                <td>1,000</td>
                                <td>0</td>
                                <td>7,000</td>
                                <td>1,500</td>
                                <td>41,839</td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>TY BSC</td>
                                <td>45,000</td>
                                <td>339</td>
                                <td>0</td>
                                <td>0</td>
                                <td>1,000</td>
                                <td>0</td>
                                <td>7,000</td>
                                <td>1,500</td>
                                <td>54,839</td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>FY MCOM</td>
                                <td>28,231</td>
                                <td>339</td>
                                <td>400</td>
                                <td>30</td>
                                <td>1,000</td>
                                <td>2,000</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>39,000</td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>SY MCOM</td>
                                <td>28,661</td>
                                <td>339</td>
                                <td>0</td>
                                <td>0</td>
                                <td>1,000</td>
                                <td>0</td>
                                <td>7,000</td>
                                <td>1,500</td>
                                <td>38,500</td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>FY MSC (CS)</td>
                                <td>67,981</td>
                                <td>339</td>
                                <td>650</td>
                                <td>30</td>
                                <td>1,000</td>
                                <td>2,000</td>
                                <td>7,000</td>
                                <td>0</td>
                                <td>79,000</td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>SY MSC (CS)</td>
                                <td>48,661</td>
                                <td>339</td>
                                <td>0</td>
                                <td>0</td>
                                <td>1,000</td>
                                <td>0</td>
                                <td>7,000</td>
                                <td>1,500</td>
                                <td>58,500</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p><strong>* Direct Second Year admission has same fee as First Year for respective course.</strong></p>
            </div>
        </div>
    </div>
</section>
